// src/pages/Moderation/ChannelsViolationsPage/model/utils.ts
import { ModerationChannel, RestrictionAgg } from './types';

export function buildRestrictionAggChannels(channels: ModerationChannel[]): RestrictionAgg[] {
  const map = new Map<number, number>();

  for (const c of channels) {
    for (const r of c.restrictions ?? []) {
      map.set(r.restriction, (map.get(r.restriction) ?? 0) + (r.cnt ?? 0));
    }
  }

  return Array.from(map.entries())
    .map(([restriction, cnt]) => ({ restriction, cnt }))
    .sort((a, b) => b.cnt - a.cnt);
}

export function restrictionsCountChannel(c: ModerationChannel) {
  return (c.restrictions ?? []).reduce((acc, r) => acc + (r.cnt ?? 0), 0);
}
